// The sign-in screen and the session states around it.
export const login = {
  // ── auth ─────────────────────────────────────────────────────────────
  'auth.checking': 'Checking your session…',
  'auth.loading': 'Loading your workspace…',
  'auth.retry': 'Start over',
  'auth.loopError': 'Sign-in kept redirecting in a loop and was stopped. Clear the session and try again.',
  'auth.loopTitle': 'Sign-in failed',
  'auth.checkingHint': 'This takes a moment',
  'auth.stuck': 'Not redirected?',
  'auth.manualSignIn': 'Click here',
  // core.md §4.3: the boot's status query failing is «سرویس در دسترس نیست» —
  // an outage with a retry, never a verdict about the account.
  'auth.bootFailed.title': 'The service is unavailable',
  'auth.bootFailed.body': 'The server did not answer. This is not a problem with your account — your patients are untouched.',
  'auth.session.expiringTitle': 'Your session is about to end',
  'auth.session.expiringBody': 'Stay signed in to keep working without interruption. What you have typed stays on screen either way.',
  'auth.session.staySignedIn': 'Stay signed in',
  'auth.session.expiredTitle': 'Your session has ended',
  'auth.session.expiredBody': 'Sign in again to continue. You will come back to this same screen.',
  'auth.session.signInAgain': 'Sign in again',
  'auth.session.returnNotice': 'What you saved is safe. What is on screen but not yet saved may be lost.',

  // ── login ────────────────────────────────────────────────────────────
  'login.title': 'Student & resident panel',
  'login.sub': 'Invent a patient, document the visit, and ask the teaching assistant why.',
  'login.action': 'Sign in or sign up with your mobile number',
  'login.working': 'Taking you to sign-in…',
  'login.hint': 'Sign-in is by phone number and a one-time code.',
  'login.feature.case.title': 'Build a practice patient',
  'login.feature.case.body': 'An imaginary person you invent. Never a real one.',
  'login.feature.visit.title': 'Document the visit',
  'login.feature.visit.body': 'SOAP note, diagnoses, prescription, orders — the way a doctor would.',
  'login.feature.chat.title': 'Talk to the teaching assistant',
  'login.feature.chat.body': 'It knows the whole record and explains how it reasons.',
  'login.free': '500 Parseh free every month',
  'login.badRedirect': 'This address is not registered for sign-in. Open the panel from its official address.',
};

export default login;
